import { Clock, DollarSign, TrendingUp, Target, Zap, PiggyBank, Timer, CheckCircle, BarChart3, ShieldCheck, Package } from "lucide-react";

const valueIcons = {
  time_saving: Clock,
  time_savings: Timer,
  cost_reduction: DollarSign,
  efficiency_gain: TrendingUp,
  efficiency: TrendingUp,
  error_reduction: Target,
  roi: Zap,
  roi_period: Zap,
  annual_savings: PiggyBank,
  inventory: Package,
  reporting: BarChart3,
  compliance: ShieldCheck,
};

const valueLabels = {
  time_saving: "Time Saving",
  time_savings: "Time Savings",
  cost_reduction: "Cost Reduction",
  efficiency_gain: "Efficiency Gain",
  efficiency: "Efficiency",
  error_reduction: "Error Reduction",
  roi: "Return on Investment",
  roi_period: "ROI Timeline",
  annual_savings: "Annual Savings",
  inventory: "Inventory",
  reporting: "Reporting",
  compliance: "Compliance",
};

const valueColors = {
  time_saving: { bg: "bg-blue-50", icon: "text-blue-600", accent: "border-blue-200" },
  time_savings: { bg: "bg-blue-50", icon: "text-blue-600", accent: "border-blue-200" },
  cost_reduction: { bg: "bg-emerald-50", icon: "text-emerald-600", accent: "border-emerald-200" },
  efficiency_gain: { bg: "bg-amber-50", icon: "text-amber-600", accent: "border-amber-200" },
  efficiency: { bg: "bg-amber-50", icon: "text-amber-600", accent: "border-amber-200" },
  error_reduction: { bg: "bg-rose-50", icon: "text-rose-600", accent: "border-rose-200" },
  roi: { bg: "bg-purple-50", icon: "text-purple-600", accent: "border-purple-200" },
  roi_period: { bg: "bg-purple-50", icon: "text-purple-600", accent: "border-purple-200" },
  annual_savings: { bg: "bg-emerald-50", icon: "text-emerald-600", accent: "border-emerald-200" },
  inventory: { bg: "bg-orange-50", icon: "text-orange-600", accent: "border-orange-200" },
  reporting: { bg: "bg-sky-50", icon: "text-sky-600", accent: "border-sky-200" },
  compliance: { bg: "bg-teal-50", icon: "text-teal-600", accent: "border-teal-200" },
};

const defaultColors = { bg: "bg-slate-50", icon: "text-slate-600", accent: "border-slate-200" };

export const ValueDelivered = ({ values }) => {
  if (!values || Object.keys(values).length === 0) return null;

  const entries = Object.entries(values);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="value-delivered">
      {entries.map(([key, value]) => {
        const IconComponent = valueIcons[key] || TrendingUp;
        const label = valueLabels[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        const colors = valueColors[key] || defaultColors;

        return (
          <div
            key={key}
            className={`flex items-start gap-3 p-3 rounded-xl ${colors.bg} border ${colors.accent}`}
            data-testid={`value-${key}`}
          >
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${colors.bg}`}>
              <IconComponent className={`h-4 w-4 ${colors.icon}`} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] font-medium text-slate-500 uppercase tracking-wide mb-0.5">{label}</p>
              <p className={`text-sm font-semibold text-slate-800 leading-snug`}>
                {value}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
